<template>
    
    <div class="dd-m-extra--share-btns">
        <ul class="dd-m-extra--share-btns__list">
            <li class="dd-m-extra--share-btns__item">
                <a v-on:click="share($event)" title="Facebook" class="dd-m-extra--share-btns__link" href="https://www.facebook.com/sharer/sharer.php?u=">
                    <i class="dd-m-icon icon-facebook"></i>
                </a>
            </li>
            <li class="dd-m-extra--share-btns__item">
                <a v-on:click="share($event)" title="Twitter" class="dd-m-extra--share-btns__link" href="https://twitter.com/share?url=">
                    <i class="dd-m-icon icon-twitter"></i>
                </a>
            </li>
            <li class="dd-m-extra--share-btns__item">
                <a v-on:click="share($event)" title="Whatsapp" class="dd-m-extra--share-btns__link dd-m-extra--share-btns__link--big" 
                    href="https://wa.me/?text=" data-action="share/whatsapp/share">
                    <i class="dd-m-icon icon-whatsapp"></i>
                </a>
            </li>
        </ul>
    </div>

</template>
<script>
    export default {
        name: 'share-btns',
        mounted() {
        },
        methods: {
            share(e) {
                e.preventDefault();
                const parent = $(e.target).closest('.dd-m-extra--share-btns__link'),
                        t = 640, 
                        n = 300, 
                        r = screen.width / 2 - t / 2, 
                        i = screen.height / 2 - n / 2;
                let link = parent.attr("href");

                link += window.location.href;

                window.open(link, "", "width=" + t + ",height=" + n + ",top=" + i + ",left=" + r);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/share-btns.vue